<template>
  <tr
    class="plan-table__item"
    v-if="paymentPlan"
    :class="{ active: active }"
  >
    <td class="plan-table__data plan-table__data_plan-name">
      {{ paymentPlan.title }}
    </td>
    <td class="plan-table__data price">
      <!-- <span class="plan-table__caption">{{ $t('price') }}:</span> -->
      <template v-if="calculatedPrice && paymentPlan.price && !partnerCode">
        {{ $t('from') }}
        {{
          formatCurrencyFromMoney(
            {
              value: calculatedPrice.withDiscount,
              currency: paymentPlan.price.currency
            }
          )
        }}
      </template>
      <template v-else-if="calculatedPrice && paymentPlan.price && partnerCode === companyPartnerCodeTypes.ROSTELECOM">
        {{
          formatCurrencyFromMoney(
            {
              value: paymentPlan.price.value,
              currency: paymentPlan.price.currency
            }
          )
        }}
      </template>
      <template v-else>
        {{ $t('free') }}
      </template>
    </td>
    <template v-if="tempQuotas">
      <PaymentPlanQuotaItem
        v-for="(quota, idx) of tempQuotas"
        :key="idx"
        :quota="quota"
      />
    </template>

    <td class="plan-table__data">
      <img
        v-if="paymentPlan.aiInterview"
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />

      <img
        v-else
        :src="require('@/assets/img/x.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data unlimited-text">
      {{ maximumVacancies }}
    </td>
    <td class="plan-table__data">
      <img
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data">
      <img
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data">
      <img
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />
    </td>

    <td class="plan-table__data">
      <img
        v-if="paymentPlan.careerPortal"
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />

      <img
        v-else
        :src="require('@/assets/img/x.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data">
      <img
        v-if="paymentPlan.multiuserMode"
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />

      <img
        v-else
        :src="require('@/assets/img/x.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data">
      <img
        v-if="paymentPlan.transcription"
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />

      <img
        v-else
        :src="require('@/assets/img/x.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data">
      <img
        v-if="paymentPlan.transcription"
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />

      <img
        v-else
        :src="require('@/assets/img/x.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data">
      <img
        v-if="paymentPlan.transcription"
        :src="require('@/assets/img/check.svg')"
        alt="check"
      />

      <img
        v-else
        :src="require('@/assets/img/x.svg')"
        alt="check"
      />
    </td>
    <td class="plan-table__data d-flex flex-column">
      <span class="plan-table__caption" />
      <template v-if="active && account.trialEnabled">
        <a @click="changePlan">{{ $t('current') }}
          <svg
            width="7"
            height="10"
            viewBox="0 0 7 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.55029 1.34924L5.10056 4.89951L1.55029 8.44978" stroke="#0A82D9" stroke-width="2" />
          </svg>
        </a>
      </template>
      <template v-else-if="active">
        <span>{{ $t('current') }}</span>
      </template>
      <template v-else-if="paymentPlan.next && !isExpired">
        <CancelNextPlan @fetchData="fetchData()" />
      </template>

      <a @click="changePlan" v-else class="plan-link">
        <template v-if="upgrade">
          {{ $t('upgrade') }}
        </template>
        <template v-else-if="renewNewPlan">
          {{ $t('upgrade') }}
        </template>
        <template v-else-if="renewCurrentPlan">
          {{ $t('renewCurrentPlan') }}
        </template>
        <template v-else>
          {{ $t('downgrade') }}
        </template>
        <svg
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.55029 1.34924L5.10056 4.89951L1.55029 8.44978" stroke="#0A82D9" stroke-width="2" />
        </svg>
      </a>
      <a
        v-if="account.trialAvailable && paymentPlan.price"
        @click="tryPlan"
        class="plan-link mt-1"
        style="color: #1FC57F"
      >
        {{ $t('try') }}
        <svg
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.55023 1.34924L5.1005 4.89951L1.55023 8.44978" stroke="#1FC57F" stroke-width="2" />
        </svg>
      </a>
    </td>
  </tr>
</template>

<script>
import PaymentPlanQuotaItem from '@/components/Payment/Plans/PaymentPlanQuotaItem';
import { computed, toRefs } from '@vue/composition-api';
import useAccount from '@/compositions/accounting/useAccount';
import useNumberFormatter from '@/compositions/useNumberFormatter';
import { useI18n } from 'vue-i18n-composable';
import usePeriod from '@/compositions/accounting/usePeriod';
import useSubscription from '@/compositions/accounting/useSubscription';
import {
  companyPartnerCodeType,
  paymentDrivers,
  paymentTabs,
  quotaItemTypes,
  quotaTypes,
  settingsTabs,
} from '@/enums';
import CancelNextPlan from '@/components/Payment/Plans/CancelNextPlan';
import useCompany from '@/compositions/useCompany';
import useAlfabank from '@/compositions/accounting/useAlfabank';

export default {
  name: 'PaymentPlanItem',
  components: {
    CancelNextPlan, PaymentPlanQuotaItem,
  },
  props: {
    paymentPlan: {
      type: Object,
      required: true,
    },
    period: {
      type: Object,
      required: false,
      default: null,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit, root: { $router, $route } }) {
    const { company } = useCompany();
    const { paymentPlan, index } = toRefs(props);
    const { account, cancelNextPlan } = useAccount();
    const { periods } = usePeriod();
    const { formatCurrencyFromMoney } = useNumberFormatter();
    const { isExpired } = useSubscription();
    const { locale, t } = useI18n();
    const { createPaymentMethodAndStartTrial } = useAlfabank();
    const partnerCode = computed(() => company.value?.companyPartnerCode);

    const actionHref = computed(() => {
      switch (partnerCode.value) {
        case companyPartnerCodeType.ROSTELECOM: {
          return 'https://hrservice.rt.ru/pay';
        }
        default: {
          return '#';
        }
      }
    });

    const calculatedPrice = computed(() => {
      const { maxDiscountPeriod } = usePeriod();
      if (!paymentPlan.value.price || !maxDiscountPeriod.value) {
        return {};
      }
      return {
        ...paymentPlan.value.price,
        withDiscount: paymentPlan.value.price.value * ((100 - maxDiscountPeriod.value.discountPercent) / 100),
      };
    });

    const upgrade = computed(() => {
      return (!isExpired.value && (!account.value.planPrice
        || (account.value.planPrice?.value < paymentPlan.value.price?.value)));
    });

    const renewNewPlan = computed(() => {
      return isExpired.value && paymentPlan.value?.id !== account.value.plan.id;
    });

    const renewCurrentPlan = computed(() => {
      return isExpired.value && paymentPlan.value?.id === account.value.plan.id;
    });

    const active = computed(() => {
      return paymentPlan.value.active && isExpired.value === false;
    });

    const maximumVacancies = computed(() => {
      return paymentPlan.value.maximumVacancies ? paymentPlan.value.maximumVacancies : t('unlimited');
    });

    function changePlan() {
      if (company.value.companyPartnerCode) {
        window.location.href = actionHref.value;
        return;
      }

      const query = isExpired.value ? { renew: isExpired.value } : {};
      $router.push({ name: 'order', params: { type: 'plan', id: paymentPlan.value.id }, query });
    }

    const tempQuotas = computed(() => {
      let hasInterviews = false;
      let hasSms = false;
      let hasCalls = false;

      const quotas = paymentPlan.value.quotas.map((q) => {
        if (q.type === quotaTypes.TEMP || q.type === quotaTypes.PERMANENT) {
          switch (q.itemType) {
            case quotaItemTypes.INTERVIEWS: {
              hasInterviews = true;
              break;
            }
            case quotaItemTypes.SMS: {
              hasSms = true;
              break;
            }
            case quotaItemTypes.CALLS: {
              hasCalls = true;
              break;
            }
            default:
          }
          return q;
        }
        return {
          ...q,
          value: 0,
        };
      });

      if (!hasInterviews) {
        quotas.push({
          itemType: quotaItemTypes.INTERVIEWS,
          value: 0,
        });
      }

      if (!hasSms) {
        quotas.push({
          itemType: quotaItemTypes.SMS,
          value: 0,
        });
      }

      if (!hasCalls) {
        quotas.push({
          itemType: quotaItemTypes.CALLS,
          value: 0,
        });
      }

      return quotas.sort((q1, q2) => {
        let q1value;
        switch (q1.itemType) {
          case quotaItemTypes.INTERVIEWS: {
            q1value = 1;
            break;
          }
          case quotaItemTypes.SMS: {
            q1value = 2;
            break;
          }
          case quotaItemTypes.CALLS: {
            q1value = 3;
            break;
          }
          default: {
            q1value = 0;
            break;
          }
        }
        let q2value;
        switch (q2.itemType) {
          case quotaItemTypes.INTERVIEWS: {
            q2value = 1;
            break;
          }
          case quotaItemTypes.SMS: {
            q2value = 2;
            break;
          }
          case quotaItemTypes.CALLS: {
            q2value = 3;
            break;
          }
          default: {
            q2value = 0;
            break;
          }
        }

        return q1value - q2value;
      });
    });

    // eslint-disable-next-line import/no-dynamic-require,global-require
    const image = require(`@/assets/img/account/plan/plan${index.value + 1}_s.svg`);

    function fetchData() {
      emit('fetchData');
    }

    const localeEn = computed(() => locale.value === 'en');

    async function tryPlan() {
      if (!account.value.hasActivePaymentMethod && account.value.driver === paymentDrivers.ALFABANK) {
        const result = await createPaymentMethodAndStartTrial(paymentPlan.value.id);

        if (result && result.redirect) {
          document.location.href = result.redirect;
        }
        return;
      }

      if (!account.value.hasActivePaymentMethod && account.value.driver === paymentDrivers.STRIPE) {
        $route.params.planId = paymentPlan.value.id;
        emit('tryPlan', paymentPlan.value.id);
        return;
      }

      $router.push({
        name: 'settings',
        params: {
          type: settingsTabs.PAYMENT,
          addType: paymentTabs.TRIAL,
          planTitle: paymentPlan.value.title,
          planId: paymentPlan.value.id,
          periodId: periods.value.find((p) => p.duration === 1)?.id,
        },
      });
    }

    return {
      account,
      changePlan,
      active,
      tempQuotas,
      calculatedPrice,
      upgrade,
      renewNewPlan,
      renewCurrentPlan,
      isExpired,
      formatCurrencyFromMoney,
      cancelNextPlan,
      image,
      fetchData,
      actionHref,
      partnerCode,
      localeEn,
      tryPlan,
      paymentDrivers,
      maximumVacancies,
    };
  },
  data() {
    return {
      companyPartnerCodeTypes: companyPartnerCodeType,
    };
  },
};
</script>

<style lang="scss" scoped>

.plan-table {
  &__item {
    width: 100%;
    @media screen and (max-width: 428px) {
      min-width: 110px;
    }
    td:nth-child(16) {
      border-bottom: none;
      background: #fff;
    }
  }
  &__data {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #212121;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70px;
    border-bottom: 1px solid #EEEEEE;
    &_plan-name {
      text-transform: uppercase;
      color: #34B8E9;
      border-bottom: none;
    }
  }
}
.active {
  background: #E7F2FE;
}

.plan-link {
  display: flex;
  align-items: center;
  svg {
    margin-left: 5px;
  }
}

.unlimited-text {
  @media screen and (max-width: 428px) {
    font-size: 11px !important;
  }
}

tr { display: block; float: left; }
th, td { display: block; }

@media screen and (max-width: 428px) {
  .plan-table {
    &__item {
      min-width: 110px;
    }
    &__data {
      font-size: 14px;
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
  current: Текущий
  upgrade: Перейти
  downgrade: Перейти
  renewCurrentPlan: Возобновить
  next: Следующий тариф
  from: от
  free: Бесплатно
  plan: Тариф
  price: Стоимость в месяц
  try: Попробовать
  ok: Ок
  cancel: Отмена
  dialogAddPaymentMethodTitle: Необходимо добавить способ оплаты
  unlimited: Неограниченно
</i18n>
<i18n lang="yml" locale="en">
  current: Current Plan
  upgrade: Select
  downgrade: Select
  renewCurrentPlan: Renew
  next: Next plan
  from: from
  free: Free
  plan: Plan
  price: Price per month
  try: Try
  ok: Ok
  cancel: Cancel
  dialogAddPaymentMethodTitle: You need to add a payment method
  unlimited: Unlimited
</i18n>
